// Local persistence — the React equivalent of the Flutter app's file_op.dart
// (userdata + login flag). Uses localStorage.

const USER_KEY = 'sli_user_data';
const LOGIN_KEY = 'sli_is_logged';

export function saveUserData(userArray) {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(userArray));
    localStorage.setItem(LOGIN_KEY, '1');
  } catch (e) {
    console.error('saveUserData', e);
  }
}

export function loadUserData() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : null;
  } catch (e) {
    return null;
  }
}

export function isLoggedIn() {
  return localStorage.getItem(LOGIN_KEY) === '1' && !!loadUserData();
}

// ── Saved sign-in, for automatic login ──────────────────────────────────────
//
// Kept SEPARATELY from the session record, even though that record also carries
// MobileNumber and Password. The session is "who is signed in now" and is wiped
// on logout; this is "sign this person back in next time" and must outlive a
// session that expires, is cleared by the server, or fails to restore. Folding
// the two together is how you get an app that either cannot sign out or cannot
// sign back in.
//
// The PIN is stored in plain text. That is inherent to logging in without
// asking: there is no secret store in a browser, and anyone who can read this
// profile's localStorage can read it. It is the same exposure the session
// record already had — it is not made worse by being named honestly — but it is
// why clearSession() below wipes it too.
const CREDS_KEY = 'sli_saved_login';

export function saveCredentials(mobileNumber, password) {
  try {
    localStorage.setItem(CREDS_KEY, JSON.stringify({
      mobileNumber: String(mobileNumber || '').trim(),
      password: String(password || ''),
    }));
  } catch (e) {
    console.error('saveCredentials', e);
  }
}

export function loadCredentials() {
  try {
    const raw = localStorage.getItem(CREDS_KEY);
    if (!raw) return null;
    const c = JSON.parse(raw);
    return c && c.mobileNumber && c.password ? c : null;
  } catch (e) {
    return null;
  }
}

export function clearCredentials() {
  localStorage.removeItem(CREDS_KEY);
}

// Signing out. Clears the saved sign-in as well — without that, the automatic
// login would put the user straight back where they just left, and Logout would
// do nothing observable.
export function clearSession() {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(LOGIN_KEY);
  clearCredentials();
}
